import { render, staticRenderFns } from "./photographic-support.vue?vue&type=template&id=877927e6&scoped=true&"
import script from "./photographic-support.vue?vue&type=script&lang=js&"
export * from "./photographic-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877927e6",
  null
  
)

export default component.exports